var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8513",
    "data-name": "Raggruppa 8513",
    transform: "translate(630 12545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8501",
    "data-name": "Raggruppa 8501",
    transform: "translate(300 300)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_4662",
    "data-name": "Rettangolo 4662",
    width: 50,
    height: 50,
    rx: 14,
    transform: "translate(-930 -12845)",
    fill: "#ff7f66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(-617.837 -12532.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11366",
    "data-name": "Tracciato 11366",
    d: "M288.3,209.613H278.134a.8.8,0,1,1,0-1.6H288.3a.8.8,0,1,1,0,1.6Zm0,0",
    transform: "translate(-263.425 -197.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11367",
    "data-name": "Tracciato 11367",
    d: "M400.806,137.6a.8.8,0,0,1-.567-1.37l3.445-3.445-3.445-3.445a.8.8,0,0,1,1.135-1.135l4.012,4.012a.8.8,0,0,1,0,1.135l-4.012,4.012A.8.8,0,0,1,400.806,137.6Zm0,0",
    transform: "translate(-379.946 -121.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11368",
    "data-name": "Tracciato 11368",
    d: "M8.558,25.683a2.2,2.2,0,0,1-.663-.1L1.457,23.438A2.159,2.159,0,0,1,0,21.4V2.148A2.142,2.142,0,0,1,2.139.008a2.206,2.206,0,0,1,.663.1L9.24,2.252A2.159,2.159,0,0,1,10.7,4.287V23.543a2.142,2.142,0,0,1-2.139,2.14ZM2.139,1.613a.537.537,0,0,0-.535.535V21.4a.556.556,0,0,0,.371.516l6.408,2.135a.581.581,0,0,0,.175.024.536.536,0,0,0,.535-.535V4.287a.556.556,0,0,0-.371-.516L2.314,1.636a.581.581,0,0,0-.174-.024Zm0,0",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11369",
    "data-name": "Tracciato 11369",
    d: "M41.645,8.566a.8.8,0,0,1-.8-.8V2.95a1.339,1.339,0,0,0-1.337-1.337H27.47a.8.8,0,0,1,0-1.6H39.505A2.944,2.944,0,0,1,42.447,2.95V7.764A.8.8,0,0,1,41.645,8.566Zm0,0",
    transform: "translate(-25.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11370",
    "data-name": "Tracciato 11370",
    d: "M186.414,285.9h-4.279a.8.8,0,1,1,0-1.6h4.279a1.339,1.339,0,0,0,1.337-1.337v-4.814a.8.8,0,1,1,1.6,0v4.814A2.944,2.944,0,0,1,186.414,285.9Zm0,0",
    transform: "translate(-172.239 -263.425)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d9d64125bd8cf0adc6f99b28181b0e59.svg";
export { ForwardRef as ReactComponent };